import { render, staticRenderFns } from "./TakipAcIslemDetayView.vue?vue&type=template&id=0a90db4a&scoped=true"
import script from "./TakipAcIslemDetayView.vue?vue&type=script&lang=ts"
export * from "./TakipAcIslemDetayView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a90db4a",
  null
  
)

export default component.exports